import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger,
} from "@/components/ui/dialog";
import { Upload } from "lucide-react";

export function BlueprintUploadDialog({ selectedFile, setSelectedFile, onUpload, uploading }) {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button
          className="bg-[#2563EB] hover:bg-[#0F172A] text-white rounded-none transition-colors duration-150 tracking-wide"
          data-testid="upload-blueprint-button"
        >
          <Upload size={16} className="mr-2" />
          UPLOAD
        </Button>
      </DialogTrigger>
      <DialogContent className="bg-white rounded-none border border-[#E2E8F0]" aria-describedby="upload-description">
        <DialogHeader>
          <DialogTitle className="font-heading font-bold text-[#0F172A]">Upload Blueprint</DialogTitle>
        </DialogHeader>
        <div id="upload-description" className="sr-only">Upload a blueprint file to the system</div>
        <div className="space-y-4">
          <div>
            <Label className="text-[#0F172A]">Select File (PDF or Image)</Label>
            <Input
              type="file"
              accept=".pdf,.png,.jpg,.jpeg"
              onChange={(e) => setSelectedFile(e.target.files[0])}
              className="mt-1 rounded-none border-[#E2E8F0]"
              data-testid="file-input"
            />
          </div>
          {selectedFile && (
            <div className="text-sm text-[#64748B] font-mono">Selected: {selectedFile.name}</div>
          )}
          <Button
            onClick={onUpload}
            disabled={!selectedFile || uploading}
            className="w-full bg-[#2563EB] hover:bg-[#0F172A] text-white rounded-none"
            data-testid="upload-submit-button"
          >
            {uploading ? "Uploading..." : "UPLOAD"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
